module.exports = __webpack_public_path__ + "assets/ca0cb61d428ec389ad58b7f71aa09584.png";